var dynamicStickerGenerator;

module.exports = dynamicStickerGenerator = {

    init: function() {
      dynamicStickerGenerator.dynamicStickerHandler();
    },

    dynamicStickerHandler: function(sticker, parent) {
    	var stickerGenerate;

    	parent.textContent = '';

    	if(!parent.classList.contains('dkt-product__sticker__wrapper')) {
    		parent.classList.add('dkt-product__sticker__wrapper');
    	}

		for(var i=0;i < sticker.length;i++) {
			stickerElt = sticker[i],
			stickerGenerate = '<em class="dkt-product__sticker__sticker js-product-sticker" data-background="'+stickerElt.backgroundColour+'" data-color="'+stickerElt.foregroundColour+'">'+stickerElt.contentText+'</em>';
			$(parent).append(stickerGenerate);
        }

        dynamicStickerGenerator.displayDynamicSticker(parent);

    },

    displayDynamicSticker : function(parent) {
    	if(parent && parent.querySelectorAll('.js-product-sticker').length > 0) {
	    	var currentSticker = parent.querySelectorAll('.js-product-sticker');

			for(var i=0;i < currentSticker.length;i++) {
				currentSticker[i].style.color           = currentSticker[i].dataset.color;
				currentSticker[i].style.backgroundColor = currentSticker[i].dataset.background;
				currentSticker[i].classList.add('dkt-product__sticker--visible');
			}
    	}
    },
};


// WEBPACK FOOTER //
// ./src/modules-es5/commons/lib/lib-sticker.js